import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {"sidePanel":"sidepanel_sidePanel__O40OZ","left":"sidepanel_left__ja1F+","right":"sidepanel_right__uVhIp","top":"sidepanel_top__Isf9t","bottom":"sidepanel_bottom__wlOuf"};
export const b = b_.with('sidePanel');